import { FormGroup } from '@angular/forms';
import { Store } from '@ngrx/store';
import { Revisione53State } from '../../../store/revisione53.reducers';
import { withInitialValueDebounced } from '@shared/operators/with-initial-value-debounced.operator';
import { Revisione53DatiBusinessSelectors } from '../../../store/selectors/dati-business.selectors';
import { take } from 'rxjs';
import { MyVerbale } from '../../../models/interfaces/revisione.interface';
import { updateVerbaleOnStore } from '@core/helpers/create-validator.helper';
import { cloneDeep } from 'lodash-es';
import { getDatiBilancioControl } from '../validators/helpers/dati-bilancio-form.helpers';

/** Reacts to my_RagSocRevIncaricataChoice: looks up the society from the store and syncs
 *  my_RagSocRevIncaricata/Desc/Convenzionata in both form and store. */
export const ragSocRevIncaricataChoiceListenerHelper = (form: FormGroup, store: Store<Revisione53State>): void => {
    const control = getDatiBilancioControl(form, 'my_RagSocRevIncaricataChoice');

    control.valueChanges.pipe(withInitialValueDebounced(control)).subscribe((ragSoc: string) => {
        store
            .select(Revisione53DatiBusinessSelectors.getSocietaRevisione(ragSoc))
            .pipe(take(1))
            .subscribe((codiceRagSoc) => {
                const my_RagSocRevIncaricataControl = getDatiBilancioControl(form, 'my_RagSocRevIncaricata');
                const my_RagSocRevIncaricataDescControl = getDatiBilancioControl(form, 'my_RagSocRevIncaricataDesc');
                const my_RagSocRevIncaricataConvenzionataControl = getDatiBilancioControl(form, 'my_RagSocRevIncaricataConvenzionata');

                updateVerbaleOnStore(store, (myVerbale) => {
                    const myVerbaleClone: MyVerbale = cloneDeep(myVerbale);
                    const bilancio = myVerbaleClone.my_SezioneI__Rilevazione.my_Bilancio;
                    if (codiceRagSoc) {
                        bilancio.my_RagSocRevIncaricata = codiceRagSoc.RagioneSociale;
                        bilancio.my_RagSocRevIncaricataDesc = codiceRagSoc.RagioneSociale;
                        bilancio.my_RagSocRevIncaricataConvenzionata = codiceRagSoc.ConvenzionataConfCoop;
                        my_RagSocRevIncaricataControl.patchValue(codiceRagSoc.RagioneSociale, { emitEvent: false });
                        my_RagSocRevIncaricataDescControl.patchValue(codiceRagSoc.RagioneSociale, { emitEvent: false });
                        my_RagSocRevIncaricataConvenzionataControl.patchValue(codiceRagSoc.ConvenzionataConfCoop, { emitEvent: false });
                    } else {
                        bilancio.my_RagSocRevIncaricata = '';
                        bilancio.my_RagSocRevIncaricataDesc = '';
                        bilancio.my_RagSocRevIncaricataConvenzionata = '';
                        my_RagSocRevIncaricataDescControl.patchValue('', { emitEvent: false });
                        my_RagSocRevIncaricataConvenzionataControl.patchValue('', { emitEvent: false });
                        my_RagSocRevIncaricataControl.patchValue('', { emitEvent: false });
                    }
                    return myVerbaleClone;
                });
            });
    });
};
